import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthModalService } from '@shared/services/auth-modal.service';
import { UserStoreService } from '@shared/stores/user-store.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authModal = inject(AuthModalService);
  const platformId = inject(PLATFORM_ID);
  const router = inject(Router);
  const userStore = inject(UserStoreService);

  const { url } = state;
  const currentUser = userStore.currentS();

  if (isPlatformBrowser(platformId) && !currentUser) {
    router.navigate(['/']);

    authModal.show('signIn', url);

    return false;
  }

  return !!currentUser;
};
